import aboutModule from "./aboutModule"
import angular from "angular"

aboutModule.controller("aboutController", ["$scope", "r2SystemVersionService",
    function ($scope, r2SystemVersionService) {

        r2SystemVersionService.getLocalVersion().then(info => {
            $scope.versionInfo = angular.isArray(info) ? info[0] : info
        })

        r2SystemVersionService.getTdnLinkForCurrentVersion().then(link => {
            $scope.currentTdnLink = link
        })

        document.getElementById("headerAbout").addEventListener("click", function () {
            document.querySelector("#headerAboutDropdown").classList.toggle("open")
        })

        $scope.openNewReleaseLink = function (url) {
            window.open(url, "_blank")
        }
    }])